import { Fragment, useRef } from "react";
import { useSelector } from "react-redux";
import { ReportingWidget } from "./reportingwidget";
import { CircularGauge, ArcGauge } from "@progress/kendo-react-gauges";
import { formatNumber, shortenNumber, isNumeric, getThemeColors, isEmptyObject } from "../../lib/utils";
import { WIDGET_GAUGE_CARD, isErrorColor } from "./utils";


const CardGaugeWidgetContent = props => {
    const {
        id, 
        fontSize, fontIsBold, fontIsUnderline, fontIsItalic, fontColor, 
        shape, min, max, isPercent, showTicks,
        decimalPlaces, trimLargeValue, isError, errorOperator, errorThreshold, beepIfError,
        data, schema, ...other 
    } = props;

    const currentTheme = useSelector(state => state.currentTheme);
    let _data = data;

    if(data == null || isEmptyObject(data))
       _data = null;

       //console.log("DATA IS", data, _data)

    let _min = (min == null || min == undefined || min == "" || !isNumeric(min)) ? null : parseFloat(min);
    let _max = (max == null || max == undefined || max == "" || !isNumeric(max)) ? null : parseFloat(max);

    //switch if both are numbers but min > max
    if (isNumeric(_min) && isNumeric(_max) && _min > _max)
    {
        let temp = _min;
        _min = _max;
        _max = temp;
    }

    let resolvedMin = _min;
    if(_min == null)
    {
        if (_data == null)
            resolvedMin = 0;
        else
            resolvedMin = isPercent && _data >=0 && _data <= 100 ? 0 : (_data > 0 ? _data*0.5 : (_data < 0 ? _data*1.5 : -50));
    }

    let resolvedMax = _max;
    if(_max == null)
    {
        if (_data == null)
            resolvedMax = 100;
        else
            resolvedMax = isPercent && _data >=0 && _data <= 100 ? 100 : (_data > 0 ? _data*1.5 :(_data < 0 ?_data*0.5 : 50));
    }

    //console.log(_data, resolvedMin, resolvedMax)
    //console.log("ISERROR", isError)
     //resolving color
     let resolvedColor = undefined;
     if (isError === true)
        resolvedColor = currentTheme.error;
     else
        resolvedColor = getThemeColors(currentTheme).find(e => e.id == fontColor).color;


    let resolvedData = (_data == null) ? "Null" : (trimLargeValue ? shortenNumber(_data, decimalPlaces) : formatNumber(_data, decimalPlaces, ","));
    if(_data != null && isPercent)
        resolvedData += "%";       

    let prps = {
        value: _data, 
        scale: {
            labels: {
                //format: null,
                //color: currentTheme.componentText,
                visible: false,
              },
            rangeSize: 26, 
            min: resolvedMin, max: resolvedMax,
            rangeLineCap: "butt",
            keyProp: (new Date().toString()),//force re-render
            minorTicks: {visible: showTicks === true ? true: false, color: currentTheme.componentText},
            majorTicks: {visible: false, color: currentTheme.componentText},
        },             
        colors:[{ to:resolvedMax, color:resolvedColor}]
    };

    const centerRenderer = (value, color) => {
        return (
          <div style={{
            fontSize: fontSize, 
            color: resolvedColor, 
            textDecoration: fontIsUnderline ? "underline" : "none", 
            fontStyle: fontIsItalic ? "italic" : "normal", 
            fontWeight: fontIsBold ? 700 : 500
          }}
          >
            {resolvedData}
          </div>
        );
    };

    return (
        <Fragment>
           <div className={`card-gauge-content card-gauge-content-${id}`}>
            {
                shape==1 &&
                <ArcGauge {...prps} style={{width: "95%"}} arcCenterRender={centerRenderer}/>
            }
            {
                shape==2 &&
                <CircularGauge {...prps} style={{width: "95%"}} centerRender={centerRenderer} />
            }
            </div>
            <style>
                {
                    `
                        .card-gauge-content
                        {
                            text-align: center;       
                            flex: 1;
                            display: flex;
                            justify-content: center;
                            align-items: stretch;     
                            height: 100%;    
                            width: 100%;          
                        }

                        .card-gauge-content .k-gauge
                        {
                            width: 90%;
                            position: relative;
                            overflow: hidden;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }
                    `
                }
            </style>
        </Fragment>
    );
};

export const CardGaugeWidget = props => {
    const {   
        id, 
        mode, 
        loaded, loading, errorText, canceled,
        backgroundColor, title, titleFontSize, titleFontIsBold, titleFontIsUnderline, titleFontIsItalic, titleFontColor,
        getContextMenu, onMenuItemClick,
        onWidgetSelect, onWidgetUnSelect, onDoubleClick, ...other} = props;
   
    //error value - since we want the title to be in error color when error condition is true, let's compute error color here
    const data = props.data;
    const errorOperator = props.errorOperator;
    const errorThreshold = props.errorThreshold;

    let resolvedTitleFontColor = titleFontColor;
    let isError = false;
    if(data != null && !isEmptyObject(data))
    {
        //console.log(">>>", data, errorOperator, errorThreshold);
        //console.log(isErrorColor(data, errorOperator, errorThreshold) === true);

     if (isErrorColor(data, errorOperator, errorThreshold) === true)
        {
            isError = true;
            resolvedTitleFontColor = 3;
        }
    }

    const isPercent = props.schema[0].IsPercent;    

    return (
        <Fragment>
            <ReportingWidget id={id} 
                widgetTypeId={WIDGET_GAUGE_CARD} dataSourceValueType={2} 
                mode={mode} loaded={loaded} loading={loading} errorText={errorText} canceled={canceled}
                backgroundColor={backgroundColor} 
                title={title} titleFontSize={titleFontSize} titleFontIsBold={titleFontIsBold} titleFontIsUnderline={titleFontIsUnderline} 
                titleFontIsItalic={titleFontIsItalic} titleFontColor={resolvedTitleFontColor}             
                getContextMenu={getContextMenu} onMenuItemClick={onMenuItemClick} 
                onWidgetSelect={onWidgetSelect} onWidgetUnSelect={onWidgetUnSelect} onDoubleClick={onDoubleClick}>
                    <CardGaugeWidgetContent {...props} isPercent={isPercent} isError={isError}/>
            </ReportingWidget>
            <style>
            {
                `
                .rpt-widget-gaugeCard
                {
                    
                }                        
                `
            }
            </style>
        </Fragment>
    );
};